import grc from "../../assets/images/GRC_preview.png";
function ArticleCaption({ captionName, captionColor }) {
  return (
    <div className="text-center position-relative" style={{ height: "120px", backgroundColor: captionColor }}>
      <div className="topimg">
        <h4 className="text-white pt-4">{captionName}</h4>
        <img src={grc} alt="GRC" style={{ width: "70px" }} />
      </div>
    </div>
  );
}
export default ArticleCaption;
